<script>
	export let name = "Elísabet Ásta";
</script>

<body>
  <header class="header">
    <div class="container">
      <h1>Betty's Notenook</h1>
      <p>A safe and secure place for you and your loved ones to store personal health information</p>
      <a href="https://youtu.be/J01en1yk3EA" target="_blank" rel="noopener noreferrer">
        <button class="cta-button">Watch video on YouTube</button>
      </a>
    </div>
  </header>

  <section class="services">
    <h2>Our Services</h2>
    <p>Our app provides a secure, digital alternative to traditional physical books used in kindergartens and schools, especially for children with specific needs.</p>
    <p>By storing information digitally and sharing it only with authorized individuals, we ensure sensitive updates are protected and accessible to parents and caregivers anytime.</p>
    <p>This approach lessens the burden on children, allowing them to focus on their day while adults manage the details.</p>
    <div class="service-cards">
      <div class="card">
        <img src="./images/chip.jpg" alt="Digital storage service">
        <h3>Secure Digital Storage</h3>
        <p>Incident registrations are kept safe at all times.</p>
      </div>
      <div class="card">
        <img src="./images/notebook.jpg" alt="Coordination service">
        <h3>Coordinated Services</h3>
        <p>Real-time updates improve coordination and overall quality of care.</p>
      </div>
      <div class="card">
        <img src="./images/playground.jpg" alt="Children's goal service">
        <h3>Clear Goals for Children</h3>
        <p>Children shouldn't manage health information — they should enjoy being kids!</p>
      </div>
    </div>
  </section>

  <!-- About Section -->
  <section class="about">
    <div class="container">
      <h2>About the Team</h2>
      <div class="about-content">
        <a href="https://www.linkedin.com/in/elísabet-ásta-ólafsdóttir-2a6129275" target="_blank" rel="noopener noreferrer">
          <img src="./images/eao.jpeg" alt="Profile picture of {name}" class="profile-pic profile-card" />
        </a>
        <div class="about-text">
          <h3>Hi, I'm {name}</h3>
          <p>
            I'm a passionate software developer focused on creating impactful tech solutions.
            Driven by a commitment to innovation and a better world, I aim to blend security with functionality to meet your needs.
            My goal is to replace the traditional notebook effectively, with your needs always in mind.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="subscribe">
    <h2>Let's be in touch!</h2>
    <a href="https://www.linkedin.com/in/elísabet-ásta-ólafsdóttir-2a6129275" target="_blank" rel="noopener noreferrer">
      <img src="./images/linkedin.svg" alt="LinkedIn Logo" class="social-icon" />
    </a>
    
    <a href="mailto:bettyolafs@gmail.com">
      <img src="./images/email.svg" alt="Mail Logo" class="social-icon" />
    </a>
  </section>

    <!-- <p>Join Betty's newsletter for the latest updates and exclusive insights.</p>
    <form>
      <input type="email" placeholder="Your email" required />
      <button type="submit">Subscribe</button>
    </form> -->

  <footer>
    <p>&copy; 2025 Betty's Notenook. All rights reserved.</p>
    <p>All images, except for profile image, are from <a href="https://unsplash.com/">unsplash.com</a></p>
    <p>CVR: 45204715</p>
  </footer>
</body>